module.exports = __webpack_public_path__ + "media/images/favicon/secondary/ms-icon-310x310-efbbf0681e546d278cafe546b5c5b01c.png";